var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgSearch = function SvgSearch(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#273943",
    fillRule: "evenodd",
    d: "M3.75 11a7.25 7.25 0 1 1 12.457 5.044.758.758 0 0 0-.163.164A7.25 7.25 0 0 1 3.75 11Zm12.884 6.695a8.75 8.75 0 1 1 1.06-1.06l3.836 3.835a.75.75 0 1 1-1.06 1.06l-3.836-3.835Z",
    clipRule: "evenodd"
  })));
};
export default SvgSearch;